<template>
  <div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="DataTable.data"
      :max-items="DataTable.length"
      :total="DataTable.total_record"
      @search="handleSearch"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.DataTable.start }} - {{ this.DataTable.end }} of
              {{ this.DataTable.total_record }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in DataTable.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th>Action</vs-th>
        <vs-th>CN Supplier ID</vs-th>
        <vs-th>Supplier Data</vs-th>
        <vs-th>Reference</vs-th>
        <vs-th>COA/Value</vs-th>
        <vs-th>Information</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="flex gap-2">
              <vx-tooltip
                text="view"
                style="margin-left: auto; margin-right: auto"
              >
                <vs-button
                  color="primary"
                  type="line"
                  icon-pack="feather"
                  v-on:click="handleView(tr)"
                  icon="icon-eye"
                />
              </vx-tooltip>
              <vx-tooltip
                text="reject"
                style="margin-left: auto; margin-right: auto"
                v-if="isApprovalForReverse && tr.status == STS_WAITING_REVERSAL"
              >
                <vs-button
                  color="danger"
                  type="line"
                  icon-pack="feather"
                  v-on:click="
                    reversalPrompt(
                      SHOW_REVERSAL_PROMPT,
                      tr,
                      ACTION_REJECT_REVERSAL
                    )
                  "
                  icon="icon-x"
                />
              </vx-tooltip>
              <vx-tooltip
                text="approve"
                style="margin-left: auto; margin-right: auto"
                v-if="isApprovalForReverse && tr.status == STS_WAITING_REVERSAL"
              >
                <vs-button
                  color="primary"
                  type="line"
                  icon-pack="feather"
                  v-on:click="
                    reversalPrompt(
                      SHOW_REVERSAL_PROMPT,
                      tr,
                      ACTION_APPROVE_REVERSAL
                    )
                  "
                  icon="icon-check"
                />
              </vx-tooltip>
            </div>
          </vs-td>
          <vs-td>{{ tr.code }}</vs-td>
          <vs-td>
            <p>ID : {{ tr.supplier_code }}</p>
            <p>Name : {{ tr.supplier_name }}</p>
          </vs-td>
          <vs-td>{{ tr.reference }}</vs-td>
          <vs-td>
            <template v-for="(tr_l, i_l) in tr.credit_note_supplier_line">
              <!-- <vs-divider
                :key="'devider-line-' + i_l"
                v-if="tr_l.value_credit > 0 && i_l > 0"
              /> -->
              <p
                :class="i_l > 0 ? 'bt pt-1' : ''"
                v-if="tr_l.value_credit > 0"
                :key="'coa-line-' + i_l"
              >
                COA: {{ tr_l.chart_of_account_name }}
              </p>
              <p
                class="mb-1"
                v-if="tr_l.value_credit > 0"
                :key="'credit-line-' + i_l"
              >
                Value Credit: {{ tr_l.value_credit }}
              </p>
            </template>
          </vs-td>
          <vs-td>
            <p>Document Date : {{ dateFormat(tr.date) }}</p>
            <p>Posting Date : {{ dateFormat(tr.posting_date) }}</p>
             <p v-if="tr.status == STS_WAITING_REVERSAL || tr.status == STS_REVERSED">
              Reversal Date : {{ dateFormat(tr.reversal_date) }}
            </p>
            <p v-if="(tr.status == STS_WAITING_REVERSAL || tr.status == STS_REVERSED) && tr.information && tr.information.note_reversal">
              Note Reversal : {{ tr.information.note_reversal }}
            </p>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="DataTable.end ? DataTable.end : 1"
      v-model="setPage"
    />
    
    <custom-prompt
      :show.sync="isReversalPromptShown"
      confirmText="Reverse"
      cancelText="Cancel"
      title="Reversal Confirmation"
      @cancel="reversalPrompt(HIDE_REVERSAL_PROMPT)"
      @confirm="changeStatus(processStatus, toBeReversedDocument, dateFormat(reversalDate))"
    >
      <p>
        {{ dialogSentence }}
        <b>{{ toBeReversedDocument ? toBeReversedDocument.code : '' }}</b>?
      </p>

      <br>

      <!-- Date Picker -->
        <div class="field">
          <label class="field-label">Reversal Date</label>
          <datepicker
            class="w-full"
            v-validate="'required'"
            name="reversalDate"
            v-model="reversalDate"
            :danger="errors.has('reversalDate')"
            placeholder="Reversal Date"
            :disabled-dates="datepickerDisabledDates"
          />
          <span
            v-show="errors.has('reversalDate')"
            class="text-danger text-sm help is-danger"
          >
            {{ errors.first("reversalDate") }}
          </span>
        </div>

        <!-- Note -->
        <div class="field">
          <label class="field-label">Reversal Note</label>
          <vs-textarea
            v-model="reversalNote"
            class="field-input"
            rows="3"
            placeholder="Add an optional note..."
          ></vs-textarea>
        </div>
    </custom-prompt>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import Template from "../../promotion_v2/discount/component/template";
import moment from "moment";
export default {
  props: ["DataTable", "view", "isApprovalForReverse"],
  components: {
    Template,
    Datepicker,
  },
  data: () => ({
    STS_OPEN: 0,
    STS_INQUIRY: 1,
    STS_WAITING_APPROVAL: 2,
    STS_APPROVED: 3,
    STS_CLOSED: 4,
    STS_REJECTED: 5,
    STS_CENCELED: 6,
    STS_WAITING_REVERSAL: 9,
    STS_REVERSED: 10,
    STS_REJECTED_REVERSAL: 11,
    HIDE_REVERSAL_PROMPT: 0,
    SHOW_REVERSAL_PROMPT: 1,
    ACTION_APPROVE_REVERSAL: "approve",
    ACTION_REJECT_REVERSAL: "reject",
    processStatus: -1,
    isReversalPromptShown: false,
    toBeReversedDocument: null,
    actionType: "",
    datepickerDisabledDates: null,
    reversalDate: new Date(),
    isShowDatepicker: true,
  }),
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
    dialogSentence() {
      if (this.actionType === this.ACTION_APPROVE_REVERSAL) {
        return "Are you sure want to reverse the document with code";
      } else if (this.actionType === this.ACTION_REJECT_REVERSAL) {
        return "Are you sure want to reject the document with code";
      } else {
        return "";
      }
    },
  },
  watch: {},
  mounted() {},
  methods: {
    dateFormat(date) {
      if (date) {
        return moment.utc(date).format("YYYY-MM-DD");
      }
    },
    handleChangePage(page) {
      this.$emit("ChangePage", page);
    },
    handleSearch(s) {
      this.$emit("Search", s);
    },
    handleChangelength(l) {
      this.$emit("ChangeLength", l);
    },
    handleView(dt) {
      this.$emit("ViewDetail", "view", dt);
    },
    changeStatus(sts, dt, reversalDate = null) {
      switch (sts) {
        case this.STS_REVERSED:
          this.$emit("ChangeStatus", sts, dt, reversalDate, this.reversalNote);
          this.reversalNote = "";
          this.isReversalPromptShown = false;
          this.toBeReversedDocument = null;
          this.reversalDate = new Date(); 
          break;
        default:
          this.$emit("ChangeStatus", sts, dt);
          break;
      }
    },
    handleEdit(dt) {
      this.$emit("ViewDetail", "edit", dt);
    },

    async copyToClipboard(toCopy) {
      try {
        await navigator.clipboard.writeText(toCopy);
        this.$vs.notify({
          title: "Success",
          text: "Copied to clipboard",
          color: "success",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check-circle",
        });
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: "Error",
          text: "Failed to copy to clipboard",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },

    closePopup() {
      this.isCloseButton = true;
      this.invoicePopup = false;
      this.reloadData(this.params);
    },

    isShowPopup(codes = []) {
      return codes.some((code) => code !== null);
    },
    print(tr) {
      let name = "cn-supplier-print";

      let routeData = this.$router.resolve({
        name: name,
        params: {
          id: tr.ID,
        },
      });
      console.log(routeData.href);
      console.log(routeData);
      window.open(routeData.href, "_blank");
    },
    reversalPrompt(action, tr = null, reversal_action = "") {
      switch (action) {
        case this.SHOW_REVERSAL_PROMPT:
          this.isReversalPromptShown = true;
          this.toBeReversedDocument = tr;
          this.reversalNote = tr.information.note_reversal;
          this.reversalDate =  tr.reversal_date? new Date(tr.reversal_date): new Date();
          this.datepickerDisabledDates = {
            to: moment.utc(this.toBeReversedDocument.posting_date).toDate(),
            from: new Date(),
          };
          break;
        case this.HIDE_REVERSAL_PROMPT:
          this.isReversalPromptShown = false;
          this.toBeReversedDocument = null;
          this.reversalDate = new Date();
          break;
      }
      this.actionType = reversal_action;
      if (reversal_action === this.ACTION_APPROVE_REVERSAL) {
        this.processStatus = this.STS_REVERSED;
        this.isShowDatepicker = true;
      } else if (reversal_action === this.ACTION_REJECT_REVERSAL) {
        this.processStatus = this.STS_REJECTED_REVERSAL;
        this.isShowDatepicker = false;
      } else {
        this.isShowDatepicker = false;
        this.processStatus = -1;
      }

      console.log("this.processStatus", this.processStatus);
      console.log("this.actionType", this.actionType);
    },
  },
};
</script>
<style scoped>
.nonfixed {
  position: inherit;
  padding-left: 20px;
}

.core-enter-active {
  transition: all 0.3s ease;
}

.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.core-enter,
.core-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.core {
  -webkit-transform-origin-y: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}

.vertical-divider {
  border-right: 1px solid #7367f0;
  /* min-height: 800px; */
  /* height: 100%; */
  -webkit-mask-position-y: fixed;
  /* padding: 5px; */
}

.vs-con-table.stripe .tr-values:nth-child(2n) {
  background: beige;
}

.colored {
  border: 1px solid #7367f0;
  position: fixed;
  left: 4%;
  top: 40%;
  max-width: 45%;
  z-index: 999999999999;
  background: antiquewhite;
  background-color: antiquewhite;
}

.bt {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
